/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { Dialog, DialogContentText, FormHelperText } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { EventEmitter } from "../../../utils/EventEmitter";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import { Grid } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import { dateConfig } from "../config";

import AccessTimeIcon from "@material-ui/icons/AccessTime";

import { mealDuration } from "../../AddWorker/components/utils";
import { useTranslation } from "react-i18next";

import onError from "./ValidateMeal";
import { getWorkerRecentClockIn } from "./../../../services/index";

export default function MealDataModal(props) {
  //translation
  const { t } = useTranslation();

  const {
    setMealData,
    setMealReminder,
    mealReminder,
    exceptionDate,
    exceptionTime,
    callingFromMissedClockOut,
    setDisableExceptionLoader,
    setDisableClockOut,
  } = props;
  const { lastPunch } = useSelector((state) => state.user);

  const [open, setOpen] = useState(true);

  const [minDate, setMinDate] = useState();
  const [recentClockIn, setRecentClockIn] = useState();
  const [maxDate, setMaxDate] = useState(new Date());
  const [valueOfTime, setValueOfTime] = useState();
  const [selectedDate, handleDateChange] = useState(
    callingFromMissedClockOut
      ? moment(
          new Date(
            exceptionDate.getFullYear(),
            exceptionDate.getMonth(),
            exceptionDate.getDate(),
            exceptionTime.getHours(),
            exceptionTime.getMinutes(),
            exceptionTime.getSeconds(),
            exceptionTime.getMilliseconds()
          )
        ).subtract(30, "minutes")
      : moment(new Date()).subtract(30, "minutes")
  );
  const [selectedTime, handleTimeChange] = useState(
    callingFromMissedClockOut
      ? moment(
          new Date(
            exceptionDate.getFullYear(),
            exceptionDate.getMonth(),
            exceptionDate.getDate(),
            exceptionTime.getHours(),
            exceptionTime.getMinutes(),
            exceptionTime.getSeconds(),
            exceptionTime.getMilliseconds()
          )
        ).subtract(30, "minutes")
      : moment(new Date()).subtract(30, "minutes")
  );
  const [mealValue, setmealValue] = useState(mealDuration[0]);

  const [submitTobe, setSubmitTobe] = useState(false);
  const [afterClick, setAfterClick] = useState(false);

  const [wrong, setWrong] = useState(false);
  const [story, setStory] = useState("");

  const handleCancel = () => {
    setMealData(false);
    setMealReminder(false);
    setDisableExceptionLoader(false);
    setDisableClockOut(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setAfterClick(true);
    const { duration, time } = e.target.elements;
    const timeInFormat4 = moment(valueOfTime).format(dateConfig.format4);
    const durationNumeric = duration.value.split(" ")[0];
    const mealData = {
      duration: durationNumeric,
      startTime: timeInFormat4,
      exceptionDate: exceptionDate,
      exceptionTime: exceptionTime,
    };
    console.log("value of time", valueOfTime);
    EventEmitter.dispatch("event", mealData);
    EventEmitter.subscribe("closePreviousMealModals", () => {
      setOpen(false);
      setMealData(false);
      setMealReminder(false);
      setDisableExceptionLoader(false);
    });
  };

  useEffect(() => {
    if (lastPunch) {
      let inTS = new Date(lastPunch.inLocalTS);
      let newMin = new Date(
        inTS.getUTCFullYear(),
        inTS.getMonth(),
        inTS.getUTCDate()
      );
      setMinDate(newMin);

      getWorkerRecentClockIn(lastPunch.workerId).then((clockIn) => {
        setRecentClockIn(clockIn);
      });

      if (mealReminder) {
        getWorkerRecentClockIn(lastPunch.workerId).then((recentClockIn) => {
          let inTS = new Date(recentClockIn);
          let newMin = new Date(
            inTS.getUTCFullYear(),
            inTS.getUTCMonth(),
            inTS.getUTCDate()
          );
          setMinDate(newMin);
        });
      }
    }

    if (callingFromMissedClockOut && exceptionDate && exceptionTime) {
      let missedClockOutDate = new Date(
        exceptionDate.getUTCFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getUTCDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      );
      setMaxDate(missedClockOutDate);
    }
  }, [lastPunch, exceptionDate, exceptionTime]);

  const mealDurationChangeHandler = (e, newValue) => {
    setAfterClick(false);
    console.log("meal empty", newValue);
    if (newValue === null || selectedDate === null) setSubmitTobe(true);
    else setSubmitTobe(false);
    setmealValue(newValue);
  };

  const errorHandler = (date) => {
    let timeStamp = new Date();
    if (exceptionDate && exceptionTime) {
      timeStamp = new Date(
        exceptionDate.getFullYear(),
        exceptionDate.getMonth(),
        exceptionDate.getDate(),
        exceptionTime.getHours(),
        exceptionTime.getMinutes(),
        exceptionTime.getSeconds(),
        exceptionTime.getMilliseconds()
      );
    }

    console.log("error handler", date, mealValue, timeStamp);
    onError(
      date,
      mealValue,
      lastPunch,
      timeStamp,
      (isWrong, isSubmitTobe, isStory) => {
        setWrong(isWrong);
        setSubmitTobe(isSubmitTobe);
        setStory(isStory);
      }
    );
  };

  useEffect(() => {
    let year = moment(selectedDate).get("year");
    let month = moment(selectedDate).get("month");
    let date = moment(selectedDate).get("date");

    let hour = moment(selectedTime).get("hour");
    let minute = moment(selectedTime).get("minute");
    let second = moment(selectedTime).get("second");
    let millisecond = moment(selectedTime).get("millisecond");

    let value;
    if (
      isNaN(year) ||
      isNaN(month) ||
      isNaN(date) ||
      isNaN(hour) ||
      isNaN(minute) ||
      isNaN(millisecond)
    )
      value = null;
    else {
      value = moment().set({
        year: year,
        month: month,
        date: date,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond,
      });
    }
    console.log("value going", value);
    errorHandler(value);
    setValueOfTime(value);
  }, [selectedDate, mealValue, selectedTime]);

  const mealTimeChangeHandler = (date) => {
    setAfterClick(false);
    if (mealValue === null || date === null) setSubmitTobe(true);
    else setSubmitTobe(false);
    if (
      callingFromMissedClockOut &&
      moment(lastPunch.inLocalTS).format(dateConfig.format6) ==
        moment(
          new Date(
            exceptionDate.getFullYear(),
            exceptionDate.getMonth(),
            exceptionDate.getDate(),
            exceptionTime.getHours(),
            exceptionTime.getMinutes(),
            exceptionTime.getSeconds(),
            exceptionTime.getMilliseconds()
          )
        ).format(dateConfig.format6)
    ) {
      date = new Date(
        moment(date).set({
          date: exceptionDate.getDate(),
          day: exceptionDate.getDay(),
          month: exceptionDate.getMonth(),
        })
      );
    }
    handleTimeChange(date);
  };

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ all: "revert", paddingLeft: 24, paddingTop: 16 }}
        >
          {t("other.mealDataTitle")}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>{t("other.mealDataText")}</DialogContentText>
            <br />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around" spacing={2}>
                <Grid item>
                  <Autocomplete
                    id="duration"
                    disableClearable
                    options={mealDuration}
                    defaultValue={mealDuration[0]}
                    getOptionLabel={(option) => option}
                    style={{ width: 250 }}
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        {...params}
                        label={t("general.selectDuration")}
                        variant="outlined"
                      />
                    )}
                    onChange={mealDurationChangeHandler}
                  />
                </Grid>

                <Grid item>
                  {(recentClockIn == undefined
                    ? moment(lastPunch.inLocalTS).format(dateConfig.format6)
                    : moment(recentClockIn).format(dateConfig.format6)) ==
                  (callingFromMissedClockOut
                    ? moment(
                        new Date(
                          exceptionDate.getFullYear(),
                          exceptionDate.getMonth(),
                          exceptionDate.getDate(),
                          exceptionTime.getHours(),
                          exceptionTime.getMinutes(),
                          exceptionTime.getSeconds(),
                          exceptionTime.getMilliseconds()
                        )
                      ).format(dateConfig.format6)
                    : moment(new Date()).format(dateConfig.format6)) ? (
                    <>
                      <KeyboardTimePicker
                        required={true}
                        ampm={false}
                        disableBackdropClick
                        inputVariant="outlined"
                        id="time"
                        value={selectedTime}
                        label={t("other.mealDataTime")}
                        onChange={mealTimeChangeHandler}
                        KeyboardButtonProps={{
                          "aria-label": "Select Punch Time",
                        }}
                        keyboardIcon={<AccessTimeIcon />}
                        error={wrong}
                      />
                      <FormHelperText error>{story}</FormHelperText>
                    </>
                  ) : (
                    <Grid container justify="space-around" spacing={2}>
                      <Grid item>
                        <KeyboardDatePicker
                          required={true}
                          ampm={false}
                          disableBackdropClick
                          inputVariant="outlined"
                          label={t("other.selectMealDate")}
                          format="MM/dd/yyyy"
                          value={selectedDate}
                          onChange={(date) => {
                            setAfterClick(false);
                            if (mealValue === null || date === null)
                              setSubmitTobe(true);
                            else setSubmitTobe(false);
                            console.log("handledatechange", date);
                            handleDateChange(date);
                          }}
                          minDate={minDate}
                          maxDate={
                            callingFromMissedClockOut
                              ? moment(
                                  new Date(
                                    exceptionDate.getFullYear(),
                                    exceptionDate.getMonth(),
                                    exceptionDate.getDate(),
                                    exceptionTime.getHours(),
                                    exceptionTime.getMinutes(),
                                    exceptionTime.getSeconds(),
                                    exceptionTime.getMilliseconds()
                                  )
                                ).format(dateConfig.format6)
                              : moment(new Date()).format(dateConfig.format6)
                          }
                          KeyboardButtonProps={
                            (console.log("exceptionDate", exceptionDate),
                            {
                              "aria-label": "Select Punch Date",
                            })
                          }
                        />
                      </Grid>

                      <Grid item>
                        <Grid container direction="column">
                          <KeyboardTimePicker
                            required={true}
                            ampm={false}
                            disableBackdropClick
                            inputVariant="outlined"
                            id="time"
                            value={selectedTime}
                            label={t("other.mealDataTime")}
                            onChange={(date) => {
                              setAfterClick(false);
                              if (mealValue === null || date === null)
                                setSubmitTobe(true);
                              else setSubmitTobe(false);
                              handleTimeChange(date);
                              errorHandler(date);
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "Select Punch Time",
                            }}
                            keyboardIcon={<AccessTimeIcon />}
                            error={wrong}
                          />
                          <FormHelperText error>{story}</FormHelperText>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCancel}
              color="primary"
              variant="outlined"
              disabled={afterClick}
            >
              {t("pgPunch.btnCancel")}
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={submitTobe || afterClick}
            >
              {t("pgHome.btEmpId")}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
MealDataModal.propTypes = {
  setMealData: PropTypes.string,
  setMealReminder: PropTypes.string,
  setDisableExceptionLoader:PropTypes.string,
  exceptionDate: PropTypes.string,
  exceptionTime: PropTypes.string,
  callingFromMissedClockOut: PropTypes.string,
  user: PropTypes.string,
  mealReminder: PropTypes.string,
};
